import { useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { makeStyles, useTheme } from "@mui/styles";
import PieChartIcon from '@mui/icons-material/PieChart';
import React from "react";
import AppConstants from "../../common/AppConstants";
import { Role } from "../../helper";
import { userService } from "../../services";
import { darkenColor } from "../../utils/appHelper";

const useStyles = makeStyles((theme) => ({
    tab: {
        fontSize: theme.typography.pxToRem(12),
    },
    tabsColor: {
        '& button': {
            color: '#ffffff !important',
        },
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 20) : theme.palette.primary.main,
    }
}));


const AdminDashboardAppBar = (props) => {

    const classes = useStyles();
    const theme = useTheme();

    const isXsDown = () => {
        return useMediaQuery(theme.breakpoints.down("xs"));
    }

    const a11yProps = (index) => {
        return {
            id: `scroll-tab-${index}`,
            "aria-controls": `scroll-tabpanel-${index}`,
        };
    }

    const userRole = userService.getUserRole();

    return (
        <AppBar position="static" color="primary" elevation={1}>
            <Tabs
                value={props.tabIndex}
                onChange={props.handleTabChange}
                scrollButtons="auto"
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                aria-label="profile tabs"
                className={classes.tabsColor}
            >
                {userRole == Role.Admin &&
                    <Tab
                        className={classes.tab}
                        icon={<PieChartIcon fontSize="small" />}
                        label={
                            !isXsDown() &&
                            AppConstants.ANALYTICS_DASHBOARD.COACH_ANALYTICS
                        }
                        {...a11yProps(1)}
                    />
                }
                {userRole == Role.Admin &&
                    <Tab
                        className={classes.tab}
                        icon={<PieChartIcon fontSize="small" />}
                        label={
                            !isXsDown() &&
                            AppConstants.ANALYTICS_DASHBOARD.APPLICATION_INSIGHTS
                        }
                        {...a11yProps(1)}
                    />
                }
            </Tabs>
        </AppBar>
    )
}

export default AdminDashboardAppBar;